module.exports = __webpack_public_path__ + "img/face-downcast-sweat.db17f4b1.svg";